import styled from 'styled-components';
import { Box, Typography } from '@mui/material';
import colors from 'src/theme/colors';

export const PanelHead = styled(Box)<{ $accentColor?: string }>`
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  background-color: ${({ $accentColor }) => $accentColor || colors.lcaMainDark};
  color: ${colors.pureWhite};
  padding: 20px 20px 20px 36px;
`;

export const PanelBody = styled(Box)`
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  border-left: 1px solid ${colors.backgroundGrey};
  border-right: 1px solid ${colors.backgroundGrey};
  border-bottom: 1px solid ${colors.backgroundGrey};
  padding: 0 20px 20px 20px;
  margin-bottom: 32px;
  background-color: ${colors.pureWhite};
`;

export const RowName = styled(Typography)<{ $accentColor?: string }>`
  color: ${({ $accentColor }) => $accentColor || colors.lcaMainDark};
`;
